import React, { Component } from 'react'
import { Form } from 'antd';
import { InputNumber } from '../../../../../components/common/input-number';

const FEE_DATA = [
    {
        id: 1,
        title: "Số tiền đặt cọc",
        feild: "deposit",
        suffix: "VNĐ",
        is_money: true
    },
    {
        id: 2,
        title: "Thời hạn thanh toán",
        feild: "payment_term",
        suffix: "ngày",
        is_money: false
    }
]

export class Deposit extends Component {

    render() {
        const { unlimitEdit, isOwner, typeOption } = this.props;
        return <>
            <div className="title-contract">8. Đặt cọc đảm bảo và thời hạn thanh toán*</div>
            {FEE_DATA.map(value => {
                return <Form.Item
                    key={value.id}
                    name={value.feild}
                    label={<div className="label-special"><div>{value.title}:</div></div>}
                    rules={[{
                        required: true,
                        message: `Vui lòng nhập ${value.title}`
                    }]
                    }
                >
                    <InputNumber className={(!isOwner && typeOption !== 'create_new') ? 'hidePrice' : ''} is_money={value.is_money} disabled={!unlimitEdit || (typeOption !== 'create_new' && !isOwner)} suffix={value.suffix} />
                </Form.Item>
            })}

        </>
    }
}
